import React from 'react';
import { motion } from 'framer-motion';
import { DumbbellIcon, CoffeeIcon, LaptopIcon, SunIcon } from 'lucide-react';
export function UseCaseCards() {
  const useCases = [{
    icon: DumbbellIcon,
    title: 'Before training',
    description: 'Clean energy without max-stim chaos.'
  }, {
    icon: CoffeeIcon,
    title: 'Morning desk',
    description: 'Start switched on without chasing coffee.'
  }, {
    icon: LaptopIcon,
    title: 'Deep work',
    description: 'Focus without feeling wired.'
  }, {
    icon: SunIcon,
    title: 'Afternoon dip',
    description: 'A better second gear than another coffee.'
  }];
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-145">
      <div className="max-w-5xl mx-auto px-6 md:px-12" data-id="element-146">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-4 mb-12" data-id="element-147">
          <h2 className="font-headline text-4xl md:text-5xl text-charcoal" data-id="element-148">
            One scoop for the parts of your day that usually fall apart.
          </h2>
          <p className="text-lg text-gray-600" data-id="element-149">
            Use it where coffee, pre-workout, or energy drinks usually start
            letting you down.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-150">
          {useCases.map((useCase, i) => {
          const Icon = useCase.icon;
          return <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.1
          }} className="bg-white rounded-3xl p-6 shadow-sm hover:shadow-md transition-shadow" data-id="element-151">
                <Icon className="w-8 h-8 text-charcoal mb-4" data-id="element-152" />
                <h3 className="font-semibold text-lg text-charcoal mb-2" data-id="element-153">
                  {useCase.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-154">
                  {useCase.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}